/* Savage Coffees theme: collection + search pages. */
/* Collection: color filter, sort, count, empty state.
   Theme: chips and counts are rendered in Liquid from custom.process_family; this script
   filters and sorts the cards on the page.
   NOTE: colour filtering belongs on Shop All, not inside a single series. */
(function () {
  var grid = document.querySelector("[data-grid]"); if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-card]"));
  var count = document.querySelector("[data-count]");
  var empty = document.querySelector("[data-empty]");
  var clear = document.querySelector("[data-clear]");
  var sort = document.querySelector("[data-sort]");
  var tastes = [], stockOnly = false;

  function apply() {
    var shown = 0;
    cards.forEach(function (c) {
      var okTaste = !tastes.length || tastes.indexOf(c.dataset.taste) > -1;
      var okStock = !stockOnly || c.dataset.stock === "true";
      var ok = okTaste && okStock;
      c.style.display = ok ? "" : "none";
      if (ok) shown++;
    });
    if (count) count.textContent = shown + (shown === 1 ? " coffee" : " coffees");
    if (empty) empty.classList.toggle("coll-empty--on", shown === 0);
    if (clear) clear.classList.toggle("filter-clear--on", tastes.length > 0 || stockOnly);
  }

  function order() {
    var mode = sort.value;
    cards.slice().sort(function (a, b) {
      if (mode === "low") return a.dataset.price - b.dataset.price;
      if (mode === "high") return b.dataset.price - a.dataset.price;
      if (mode === "name") return a.dataset.name.localeCompare(b.dataset.name);
      return a.dataset.order - b.dataset.order;
    }).forEach(function (c) { grid.appendChild(c); });
  }

  document.querySelectorAll("[data-taste-filter]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      var t = chip.dataset.tasteFilter, i = tastes.indexOf(t);
      if (i > -1) { tastes.splice(i, 1); } else { tastes.push(t); }
      chip.classList.toggle("swatch-chip--on", i === -1);
      chip.setAttribute("aria-pressed", String(i === -1));
      apply();
    });
  });
  var stockChip = document.querySelector("[data-stock-filter]");
  if (stockChip) stockChip.addEventListener("click", function () {
    stockOnly = !stockOnly;
    stockChip.classList.toggle("swatch-chip--on", stockOnly);
    stockChip.setAttribute("aria-pressed", String(stockOnly));
    apply();
  });
  if (clear) clear.addEventListener("click", function () {
    tastes = []; stockOnly = false;
    document.querySelectorAll("[data-taste-filter], [data-stock-filter]").forEach(function (c) { c.classList.remove("swatch-chip--on"); c.setAttribute("aria-pressed", "false"); });
    apply();
  });
  if (sort) sort.addEventListener("change", order);
  apply();
})();

(function () {
  document.querySelectorAll("[data-jump]").forEach(function (b) {
    b.addEventListener("click", function () {
      var card = document.querySelector('.product-card[data-id="' + b.dataset.jump + '"]'); if (!card) return;
      card.style.display = "";
      card.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "center" });
      card.classList.remove("is-flash"); void card.offsetWidth; card.classList.add("is-flash");
    });
  });
})();

(function(){var c=document.querySelector("[data-count]");if(!c||!c.dataset.word||c.dataset.word==="coffees")return;new MutationObserver(function(){var t=c.textContent;if(/coffee/.test(t))c.textContent=t.replace(/coffees?/,parseInt(t)===1?"product":"products");}).observe(c,{childList:true,characterData:true,subtree:true});c.textContent=c.textContent;})();

/* Green coffee: "Add 1kg" adds the product's green variant with the Ajax Cart API, then asks the
   cart drawer to refresh (savage-cart.js listens for cart:refresh). */
(function () {
  document.querySelectorAll("[data-green-variant]").forEach(function (b) {
    b.addEventListener("click", function () {
      var label = b.querySelector(".button-label"), was = label.textContent;
      b.disabled = true;
      fetch((window.Savage && Savage.routes.cart_add || "/cart/add") + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: +b.dataset.greenVariant, quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        b.disabled = false;
        if (res && res.status) { label.textContent = "Unavailable"; setTimeout(function () { label.textContent = was; }, 1800); return; }
        b.classList.add("is-added"); label.textContent = "Added";
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
        setTimeout(function () { b.classList.remove("is-added"); label.textContent = was; }, 1800);
      }).catch(function () { b.disabled = false; });
    });
  });
  var est = 0, unit = "kg";
  function paint() {
    document.querySelectorAll(".offer-item[data-p0]").forEach(function (it) {
      it.querySelector("[data-price]").textContent = it.dataset[(unit === "kg" ? "p" : "l") + est];
      it.querySelector("[data-unit]").textContent = "per " + unit;
    });
  }
  function seg(sel, fn) {
    var g = document.querySelector(sel); if (!g) return;
    g.addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b) return;
      g.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      fn(b); paint();
    });
  }
  seg("[data-est]", function (b) { est = +b.dataset.e; });
  seg("[data-unitsel]", function (b) { unit = b.dataset.u; });
})();

/* Search: Coffee / Pages tabs jump to their group (both groups stay visible, as designed). */
(function () {
  var tabs = document.querySelector("[data-search-tabs]"); if (!tabs) return;
  tabs.addEventListener("click", function (e) {
    var b = e.target.closest("[data-tab]"); if (!b) return;
    tabs.querySelectorAll("[data-tab]").forEach(function (x) { x.setAttribute("aria-selected", String(x === b)); });
    var p = document.querySelector('[data-tab-panel="' + b.dataset.tab + '"]');
    if (p) p.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
  });
})();
